<template lang="pug">
control
  field(:class="{ invalid: !integer.meta.valid && integer.meta.touched }")
    label(:for="integer.id" v-html="integer.label")
    input(
      @blur="integer.blur",
      @keydown.up.prevent="integer.increase",
      @keydown.down.prevent="integer.decrease",
      v-model="integer.model",
      :type="integer.type",
      :inputmode="integer.inputmode",
      :pattern="integer.pattern",
      :name="integer.id",
      :id="integer.id",
      :placeholder="integer.placeholder",
    )
    error(v-if="!integer.meta.valid && integer.meta.touched") {{ integer.errorMessage }}
</template>

<script>
import { useStore } from "vuex";
import { reactive, ref, watch, onMounted } from "vue";
import { useField } from "vee-validate";
import * as yup from "yup";

export default {
  name: "integer",
  props: {
    field: Object,
  },
  setup(p, { emit }) {
    const store = useStore();
    const integer = reactive(initInteger());

    return { integer };

    function initInteger() {
      let labelHtml = p.field.label;
      if (labelHtml && p.field.required !== false) labelHtml = `<b>${labelHtml}</b>`;

      const id = p.field.id;
      const label = labelHtml ? `${labelHtml}${p.field.required !== false ? " <span class='required'>*</span>" : ""}` : null;
      const type = "text";
      const inputmode = "numeric";
      const step = "1";
      const pattern = "[0-9]+";

      let rules = yup
        .number()
        .positive()
        .integer()
        .min(Object.hasOwn(p.field, 'min') ? p.field.min : 1)
        .nullable();

      if (p.field.max) rules = rules.max(p.field.max);
      if (p.field.required !== false) rules = rules.required();

      const { value, errorMessage, meta, handleBlur, validate } = useField(
        id,
        rules,
        {
          validateOnInput: true,
          initialValue: store.getters.model[p.field.id],
        }
      );

      const model = ref(/*fixed*/);
      const initial = ref(true);

      watch(
        () => store.getters.model[p.field.id],
        (v) => (model.value = v)
      );

      watch(model, (v) => {
        if (Object.hasOwn(store.getters.model, p.field.id) || initial.value) {
          if (!v && v !== 0) {
            model.value = "";
            if (p.field.required !== false) value.value = 0
            else value.value = null
          }
          else {
            v = Math.abs(parseInt(v));
            if (model.value !== v) {
              model.value = v;
            }
            value.value = v;
          }
          initial.value = false;
          store.commit("updateModel", { id: p.field.id, value: v });
        }
      });

      model.value = store.getters.model[p.field.id];

      const increase = () => {
        let value = model.value || 0;
        model.value = ++value;
      };

      const decrease = () => {
        let value = model.value || 0;
        if (value >= 1) {
          model.value = --value;
        }
      };

      const blur = async () => {
        store.commit('pushLastFieldToDataLayer', id);
        await validate();
        handleBlur();
        emit('change', { model: model.value, meta });
      };

      const placeholder = p.field.required === false
        ? ""
        : "(Required)";

      onMounted(() => {
        emit('init', { model: model.value, meta });
      })

      return {
        id,
        label,
        type,
        inputmode,
        step,
        pattern,
        model,
        meta,
        blur,
        increase,
        decrease,
        errorMessage,
        placeholder
      };
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
